module.exports = __webpack_public_path__ + "media/images/emblems/Fiez-coat_of_arms-d5831c4a940febb9d92f005a4018fd64.svg";